import { AddonType, OrderAddonType } from './addon.model';

export enum ENUM_ADDON_SELECTION {
  MULTI_SELECTION = 'MULTI_SELECTION',
  SINGLE_SELECTION = 'SINGLE_SELECTION',
  MULTI_SELECTION_WITH_QUANTITY = 'MULTI_SELECTION_WITH_QUANTITY'
}

export type MealAddonCategoryType = {
  id: string;
  name: string;
  active: boolean;
  summary: string;
  position: number;
  created_at: string;
  updated_at: string;
  selection_no: string;
  meal_parent_id: string;
  meal_default_id: string;
  meal_category_id: string;
  min_selection_no: string;
  meal_category_selection_type: {
    id: string;
    name: ENUM_ADDON_SELECTION;
  };
};
export type AddonCategoryType = {
  id: string;
  name: string;
  summary: string;
  active: boolean;
  created_at: string;
  updated_at: string;
  selection_no: string;
  meal_category_id: string;
  meal_parent_id: string;
  meal_default_id: string;
  position: number;
  addons: AddonType[];
  meal_category_selection_type: {
    name: ENUM_ADDON_SELECTION;
    id: string;
  };
};

export type UpdateOrderAddonCategoryType = {
  id: string;
  name: string;
  summary: string;
  selection_type: 'SINGLE_SELECTION' | 'MULTI_SELECTION' | 'MULTI_SELECTION_WITH_QUANTITY';
  max_selection: number;
  addons: OrderAddonType[];
};

export type UpdateOrderAddonType = {
  id: string;
  name: string | null;
  quantity: number;
  amount: number;
  default: boolean;
};
